import { breakpoints, vars } from '@etg/wings';
import { css } from '@eti/styles';
import checkIcon from '@eti/assets/icons/checkList.svg?url';
export const infantNoteStyles = css`
  grid-area: 4 / 1 / 5 / 4;
  margin-top: 16px;

  & > svg {
    flex-shrink: 0;
    height: 16px;
    transform: translateY(2px);
    width: 16px;
  }
`;
export const flexibleTicketCtaGridLayoutStyles = (isSelectboxLabel, isSmallCardLayout = false) => css`
  column-gap: 8px;
  display: grid;
  grid-template-columns: 2fr auto;
  grid-template-rows: repeat(3, auto);

  @media (min-width: ${breakpoints._768}) {
    justify-content: end;
    margin-top: ${isSmallCardLayout ? '8px' : ''};
  }

  &.cta {
    .price__label.priceLabel {
      grid-area: 2 / 3 / 2 / 4;
      margin-top: ${isSmallCardLayout ? '0px' : '24px'};

      @media (min-width: ${breakpoints._768}) {
        grid-area: 3 / 1 / 3 / 2;
        margin-top: ${isSelectboxLabel ? '24px' : '4px'};
      }
    }
  }

  .price {
    grid-area: 3 / 3 / 4 / 4;

    @media (min-width: ${breakpoints._768}) {
      grid-area: 4 / 1 / 4 / 2;
    }
  }
`;
export const textContentStyles = iconContent => css`
  grid-area: 1 / 1 / 2 / 4;

  > *:not(:last-child) {
    margin-bottom: 16px;
  }

  & p {
    font-size: 0.875rem;

    @media (min-width: 48em) {
      line-height: 150%;
    }
  }

  & li {
    padding-inline-start: 24px;
    position: relative;

    [dir='rtl'] & {
      padding-left: 0;
    }

    &::before {
      background: url(${checkIcon});
      background-repeat: no-repeat;
      background-size: contain;
      content: '';
      height: 16px;
      inset-inline-start: 0;
      margin-inline-end: 8px;
      position: absolute;
      top: 3px;
      width: 16px;
    }
  }

  & a {
    color: ${vars.colors.links.default};
  }

  & a::after {
    content: ${iconContent !== null && iconContent !== void 0 ? iconContent : ''};
    margin-inline-start: 2px;
    position: relative;
    top: 3.1px;
  }
`;
//# sourceMappingURL=styles.js.map